import { StoreProps } from '@interfaces/StoreState'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

export const TAB_IDS = {
  STUDENT_BOOK: 'student-book',
  STUDENT_MY_CALENDAR: 'student-my-calendar',
  INSTRUCTOR_MY_SCHEDULE: 'instructor-my-schedule',
  INSTRUCTOR_MY_LESSONS: 'instructor-my-lessons',
  INSTRUCTOR_PENDING_LESSONS: 'instructor-pending-lessons',
} as const

export const TAB_NUMBERS = {
  STUDENT_BOOK: 1,
  STUDENT_MY_CALENDAR: 2,
  INSTRUCTOR_MY_SCHEDULE: 1,
  INSTRUCTOR_MY_LESSONS: 2,
  INSTRUCTOR_PENDING_LESSONS: 3,
} as const

const StudentTitle = () => {
  const title = useSelector(({ mySchedules }: StoreProps) => mySchedules.title)

  return (
    <a>
      <FormattedMessage id={title} />
    </a>
  )
}

const menu = {
  student: [
    {
      tab: 1,
      id: TAB_IDS.STUDENT_BOOK,
      link: '/scheduling',
      child: <StudentTitle />,
    },
    {
      tab: 2,
      id: TAB_IDS.STUDENT_MY_CALENDAR,
      link: '/scheduling/my-calendar',
      child: (
        <a>
          <FormattedMessage id="My calendar" />
        </a>
      ),
    },
  ],
  instructor: [
    {
      tab: 1,
      id: TAB_IDS.INSTRUCTOR_MY_SCHEDULE,
      link: '/instructors/scheduling',
      child: (
        <a>
          <FormattedMessage id="My schedule" />
        </a>
      ),
    },
    {
      tab: 2,
      id: TAB_IDS.INSTRUCTOR_MY_LESSONS,
      link: '/instructors/scheduling/my-lessons',
      child: (
        <a>
          <FormattedMessage id="My lessons" />
        </a>
      ),
    },
    {
      tab: 3,
      id: TAB_IDS.INSTRUCTOR_PENDING_LESSONS,
      withBadge: true,
      link: '/instructors/scheduling/pending-lessons',
      child: (
        <a>
          <FormattedMessage id="Pending lessons" />
        </a>
      ),
    },
  ],
}

export const pendingLessonContracts = ['freelance']

export default menu